import { HttpHeaders, HttpParams, HttpClient, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

export abstract class AbstractEntityService {

    protected abstract resourceUrl: string;
    protected abstract resourceCountUrl: string;

    constructor(protected http: HttpClient) {}

    protected createRequestOption(req?: any, extended?: boolean): {} {
        let httpParams: HttpParams = new HttpParams();
        if (req) {
            if (req.page) {
                httpParams = httpParams.set('page', req.page);
            }
            if (req.size) {
                httpParams = httpParams.set('size', req.size);
            }

            if (req.sort) {
                httpParams = httpParams.set('sort', req.sort);
            }

            if (req.query) {
                httpParams = httpParams.set('query', req.query);
            }
        }

        let httpHeaders: HttpHeaders = new HttpHeaders();
        if (extended) {
            httpHeaders = httpHeaders.set('prefer', 'return=representation')
                                     .set('Vary', 'Prefer, Accept, Accept-Encoding');
        }

        return {headers: httpHeaders, params : httpParams, observe: 'response'};
    }

    delete(id: number): Observable<string> {
        return this.http.delete(`${this.resourceUrl}/${id}`, {responseType: 'text'});
    }

    count(req?: any): Observable<number> {
        let options = this.createRequestOption(req);
        options['responseType'] = 'text';
        return this.http.get<HttpResponse<any>>(this.resourceCountUrl, options)
            .map((res: any) => {
                return parseInt(res.body.length !== 0 ? res.body.toString() : 0, 10);
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/service/abstract-entity.service.ts